import { render, staticRenderFns } from "./DebitOrderApproval.vue?vue&type=template&id=4563a32a&scoped=true"
import script from "./DebitOrderApproval.vue?vue&type=script&lang=js"
export * from "./DebitOrderApproval.vue?vue&type=script&lang=js"
import style0 from "./DebitOrderApproval.vue?vue&type=style&index=0&id=4563a32a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563a32a",
  null
  
)

export default component.exports